import React, { useState } from "react";

const UpdateStatusModal = ({ isOpen, onClose, order, onUpdate }) => {
  const [status, setStatus] = useState(order.status);

  if (!isOpen) return null;

  const statusColors = {
    "Pendiente": "bg-yellow-500",
    "En Proceso": "bg-blue-500",
    "Completado": "bg-green-500",
    "Cancelado": "bg-red-500"
  };

  const saveStatus = () => {
    if (onUpdate) onUpdate(order.id, status); // llama al handler de Pedidos para actualizar
    onClose();
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4">
      <div className="bg-gray-900 p-6 rounded-lg w-96">
        <h2 className="text-xl font-bold mb-4 text-white">Actualizar Estado - {order.id}</h2>

        <label className="block mb-2 text-gray-400 font-semibold">Estado Actual</label>
        <div className={`p-2 rounded mb-4 text-white ${statusColors[status]}`}>{status}</div>

        <label className="block mb-2 text-gray-400 font-semibold">Cambiar Estado</label>
        <select
          className="w-full mb-4 rounded-md bg-gray-800 text-white p-2"
          value={status}
          onChange={(e) => setStatus(e.target.value)}
        >
          {Object.keys(statusColors).map((s) => (
            <option key={s}>{s}</option>
          ))}
        </select>

        <button
          onClick={saveStatus}
          className="mb-2 w-full rounded-md bg-primary-600 px-4 py-2 text-white hover:bg-primary-700 transition-colors"
        >
          Guardar
        </button>
        <button
          onClick={onClose}
          className="w-full rounded-md bg-gray-700 px-4 py-2 text-white hover:bg-gray-600 transition-colors"
        >
          Cancelar
        </button>
      </div>
    </div>
  );
};

export default UpdateStatusModal;
